import { ReactNode } from "react";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { useTranslation } from "react-i18next";
import GenericButton from "@/components/forms/inputs/button/genericButton";
import styles from "@/components/userAdministration/csvUploadSteps.module.css";

interface Props {
  downloadTemplateLabel: string;
  onDownloadTemplate: () => void;
  uploadInput: ReactNode;
}

export default function CsvUploadSteps({
  downloadTemplateLabel,
  onDownloadTemplate,
  uploadInput,
}: Props) {
  const { t } = useTranslation();

  return (
    <ol className={styles.steps}>
      <li className={styles.step}>
        <span className={styles.stepNumber}>1</span>
        <div className={styles.stepContent}>
          <h4 className={styles.stepTitle}>
            {t("csv_upload_step_download_template")}
          </h4>
          <GenericButton
            variant="outlined"
            color="tertiary"
            startIcon={<FileDownloadIcon />}
            onClick={onDownloadTemplate}
          >
            {downloadTemplateLabel}
          </GenericButton>
        </div>
      </li>
      <li className={styles.step}>
        <span className={styles.stepNumber}>2</span>
        <div className={styles.stepContent}>
          <h4 className={styles.stepTitle}>
            {t("csv_upload_step_upload_file")}
          </h4>
          {uploadInput}
        </div>
      </li>
    </ol>
  );
}
